import React from 'react';

const Footer = () => (
  <footer className="footer">
    <p>&copy; 2024 Blue Spoke</p>
  </footer>
);

export default Footer;
